import{Locale as e}from"../../../locale/Locale.enum.mjs";const o={notReferTo:new Map([[e.ja,"参照しない"]]),referTo:new Map([[e.ja,"参照する"]]),optionallyReferTo:new Map([[e.ja,"参照任意"]])};export{o as mstReferenceNameConfig};
